import React from 'react';

// Soft botanical sprig — used as a subtle decorative motif throughout.
export function Leaf({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 80 120" fill="none" className={className} aria-hidden="true" data-id="element-200" data-mp="2r24dbxstzvul">
      <path d="M40 118V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-201" data-mp="2m7rrjh3vu8fo" />
      <path d="M40 30C40 30 24 26 16 36C24 46 40 42 40 42" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-202" data-mp="2i6xzqcnbk9hi" />
      <path d="M40 30C40 30 56 26 64 36C56 46 40 42 40 42" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-203" data-mp="2890gk3kbh2vr" />
      <path d="M40 50C40 50 26 46 18 56C26 66 40 62 40 62" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-204" data-mp="23cjgqc3r902u" />
      <path d="M40 50C40 50 54 46 62 56C54 66 40 62 40 62" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-205" data-mp="1i2en9mqowpm" />
      <path d="M40 70C40 70 28 66 22 74C28 82 40 78 40 78" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-206" data-mp="3pmq9xh2841b" />
      <path d="M40 70C40 70 52 66 58 74C52 82 40 78 40 78" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-207" data-mp="8qan4zryzf3g" />
    </svg>;
}